export default {
  name: "Preliminary Questions",
  sections: [
    {
      fields: [
        {
          isGroup: {
            code: "A.5",
            machine_name: "a5_is_emergency",
            label:
              "Is this application being filed with a request to waive the regulatory time period due to an emergency situation, as defined by 20 CFR 655.134?",
            tooltip:
              "If the application is submitted less than 45 days before the employer’s first date of need, select “Yes” or “No” to indicate whether the employer’s application is being filed with a request to waive the regulatory time period due to an emergency situation. Pursuant to 20 CFR 655.134(a), the CO may waive the time period for filing for employers who did not make use of temporary foreign agricultural workers during the prior year's agricultural season or for any employer that has other good and substantial cause, provided that the CO has sufficient time to test the domestic labor market on an expedited basis to make the determinations required by 20 CFR 655.100.",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                clearFiles: ["a6_is_emergency_justification_complete"],
                validate: [
                  {
                    isRequired: "e3_is_job_order_complete",
                    message: "This field is required to continue.",
                    needsFieldValues: true,
                    extraData: {
                      check: "ifValueExists",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                clearFiles: ["a6_is_emergency_justification_complete"],
                validate: ["required"],
              },
            ],
          },
        },
        {
          machine_name: "a6_is_emergency_justification_complete",
          name: "Emergency Justification Statement",
          code: "A.6",
          fileTypes: [".pdf", ".png", ".jpg"],
          isVisible: {
            when: "a5_is_emergency",
            is: "YES",
          },
          widget: "file_upload",
          label: `If “Yes” is marked in question A.5, a statement justifying the employer’s emergency situation is attached to this application.`,
          validate: ["required", "checkValue"],
          tooltip: `
          <strong><i>Important Note:</i></strong> Pursuant to 20 CFR 655.134(b), an employer must submit, at the time of filing, a statement justifying the request for a waiver of the time period requirement. The statement must indicate whether the waiver request is due to the fact that the employer did not use H-2A workers during the prior agricultural season or whether the request is for good and substantial cause. If the waiver is requested for good and substantial cause, the employer's statement must also include detailed information describing the good and substantial cause which has necessitated the waiver request. Good and substantial cause may include, but is not limited to, the substantial loss of U.S. workers due to Acts of God (e.g., weatherrelated activities) or similar unforeseeable man-made catastrophic events, unforeseen events affecting the work activities to be performed, pandemic health issues, or similar conditions that are wholly outside of the employer’s control.
          `,
        },
      ],
    },
    {
      coloring: "blue",
      fields: [
        {
          code: "E.3",
          machine_name: "e3_is_job_order_complete",
          widget: "job_order_lookup",
          unlinkWhen: "a5_is_emergency",
          label:
            "A copy of the completed job order (Form ETA-790/790A) satisfying the requirements at 20 CFR 653, subpart F, and 20 CFR 655, subpart B,  is attached to this application.",
          validate: [
            {
              isRequired: "e3_is_job_order_complete",
              message: "This field is required to continue.",
              needsFieldValues: true,
              extraData: {
                check: "ifValueExists",
              },
            },
          ],
          tooltip:
            "Select the completed job order (Form ETA-790A) to be submitted with this application. Reminder: The job order must satisfy all requirements listed at 20 CFR 653, subpart F, and 20 CFR 655.122.",
          info: "<span>If you do not have a relevant <a href=''>Form ETA-790/790A</a>, H-2A Agricultural Clearance Order, please complete one and return to this form once you have submitted.",
        },
      ],
    },
  ],
};
